import axios from 'axios';
import ls from 'local-storage';
import router from '../router';

const API_URL = process.env.VUE_APP_API_URL;
let TOKEN = ls('TOKEN') || false;

// Token du local storage
if (TOKEN) {
  axios.defaults.headers.common.Authorization = `Bearer ${TOKEN.token}`;
}

// Récupération par axios d'une 401 (unuthorized) et redirection login
axios.interceptors.response.use(null, (error) => {
  if (error.response.status === 401) {
    ls.remove('TOKEN');
    router.push({ name: 'login' });
  }
  return Promise.reject(error);
});

// Récupération du token
const getToken = () => ls('TOKEN');

// L'utilisateur est-il loggué
const isLoggedIn = () => !!getToken();

// Login
const login = (log, pass) => {
  const promise = new Promise((fulfill, reject) => {
    axios.post(`${API_URL}/login`, {
      email: log,
      password: pass,
    }).then((response) => {
      TOKEN = response.data;
      ls('TOKEN', response.data);
      axios.defaults.headers.common.Authorization = `Bearer ${TOKEN.token}`;

      fulfill(true);
    }).catch(() => {
      reject();
    });
  });

  return promise;
};

const logout = () => {
  const promise = new Promise(() => {
    ls.remove('TOKEN');
    ls.remove('STATUS');
    router.go({ name: 'login' });
  });

  return promise;
};

const getAuthorizationHeader = () => axios.defaults.headers.common.Authorization;


const auth = {};
auth.login = login;
auth.isLoggedIn = isLoggedIn;
auth.logout = logout;
auth.getToken = getToken;
auth.getAuthorizationHeader = getAuthorizationHeader;

export default auth;
